import { ApplicationConfig, provideZoneChangeDetection, isDevMode, PLATFORM_ID, Inject, inject, provideAppInitializer, APP_INITIALIZER, Injectable } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideFunctions } from '@angular/fire/functions';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { provideStorage } from '@angular/fire/storage';
import { provideAuth } from '@angular/fire/auth';
import { provideFirestore } from '@angular/fire/firestore';

import { environment } from '../environments/environment';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { WebsiteService } from './services/website.service';
import { WebsiteStateService } from './state-management/services/website-state.service';
import { ScreensizeStateService } from './state-management/services/screensize-state.service';
import { initializeAppFactory } from './init.factory';
import { authFactory } from './factories/auth-factory';
import { functionsFactory } from './factories/functions-factory';
import { storageFactory } from './factories/storage-factory';
import { firestoreFactory } from './factories/firestore-factory';
import { MatPaginatorIntl } from '@angular/material/paginator';
// import { CustomMatPaginatorIntl } from './components/meta/website-config/website-config-form/website-config-reviews/website-config-reviews-select/website-config-reviews-select.component';


@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Einträge pro Seite:';
  override nextPageLabel = 'Nächste Seite';
  override previousPageLabel = 'Vorherige Seite';
  override firstPageLabel = 'Erste Seite';
  override lastPageLabel = 'Letzte Seite';
}



export const appConfig: ApplicationConfig = {
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAnalytics(() => getAnalytics()),
    provideFunctions(functionsFactory()),
    provideStorage(storageFactory()),
    provideAuth(authFactory()),
    provideFirestore(firestoreFactory()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),

    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },

    WebsiteService,
    WebsiteStateService,
    ScreensizeStateService,
    provideAppInitializer(() => {
      const initializerFn = (initializeAppFactory)(inject(WebsiteService), inject(WebsiteStateService));
      return initializerFn();
    }),
    provideRouter([]),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};